import { Component } from '@angular/core';
import { filter } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../basic-features/icon-v2/icon.component";
import * as i4 from "primeng/tooltip";
import * as i5 from "@ngx-translate/core";
const _c0 = a0 => ({
  "index-up": a0
});
const _c1 = a0 => ({
  disabledMenuItem: a0
});
function ContextMenuComponent_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵlistener("dblclick", function ContextMenuComponent_div_2_div_1_Template_div_dblclick_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    })("click", function ContextMenuComponent_div_2_div_1_Template_div_click_0_listener($event) {
      const item_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.isItemDisabled(item_r2.action) ? $event.stopPropagation() : ctx_r2.menuItemClicked(item_r2.action, $event));
    });
    i0.ɵɵelement(2, "geaui-icon-v2", 6);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    const item_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pTooltip", i0.ɵɵpipeBind1(1, 7, (tmp_3_0 = item_r2 == null ? null : item_r2.disabledTranslationKey) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "X.INFO.NO_ACCESS.ACTION_UNAVAILABLE"))("tooltipDisabled", !ctx_r2.isItemDisabled(item_r2.action))("ngClass", i0.ɵɵpureFunction1(11, _c1, ctx_r2.isItemDisabled(item_r2.action)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("fileSize", 16)("file", item_r2.icon)("color", ctx_r2.isItemDisabled(item_r2.action) ? "grey" : "black");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 9, item_r2.text));
  }
}
function ContextMenuComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, ContextMenuComponent_div_2_div_1_Template, 6, 13, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.config == null ? null : ctx_r2.config.items);
  }
}
export var ContextMenuAction;
(function (ContextMenuAction) {
  ContextMenuAction["OPEN_CONTEXT_MENU"] = "open-context-menu";
  ContextMenuAction["CLOSE_CONTEXT_MENU"] = "close-context-menu";
})(ContextMenuAction || (ContextMenuAction = {}));
/**
 * @deprecated use v3 version of this component instead
 */
export class ContextMenuComponent {
  tableService;
  renderer;
  el;
  config;
  rowData;
  columnKey;
  tableId;
  open = false;
  clickListener;
  _actionsSubject;
  constructor(tableService, renderer, el) {
    this.tableService = tableService;
    this.renderer = renderer;
    this.el = el;
    this.clickListener = this.renderer.listen('document', 'click', event => {
      this.closeContextMenu(event);
    });
  }
  ngOnInit() {
    this._actionsSubject = this.tableService.actions.pipe(filter(action => action.tableId === this.tableId), filter(action => action.action === ContextMenuAction.OPEN_CONTEXT_MENU.toString()), filter(action => action.rowData !== this.rowData)).subscribe(() => {
      this.open = false;
    });
  }
  toggleContextMenu(event) {
    event.stopPropagation();
    this.open = !this.open;
    if (this.tableId) {
      this.tableService.publishAction(this.tableId, this.open ? ContextMenuAction.OPEN_CONTEXT_MENU : ContextMenuAction.CLOSE_CONTEXT_MENU, this.rowData);
    }
  }
  menuItemClicked(action, event) {
    if (this.tableId) {
      event.stopPropagation();
      this.open = false;
      this.tableService.publishAction(this.tableId, action, this.rowData);
    }
  }
  isItemDisabled(action) {
    const currentAction = this.config?.items.find(item => item.action === action);
    if (currentAction?.disabledFor && this.rowData) {
      // Accessing a property like that has to be allowed here to keep the table flexible
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
      return this.rowData[currentAction.disabledFor.columnKey] === currentAction.disabledFor.columnValue;
    }
    if (currentAction?.disabledForFunction && this.rowData) {
      return currentAction.disabledForFunction(this.rowData);
    }
    return false;
  }
  closeContextMenu(event) {
    // types have to be any here
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    const clickedInside = this.el.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.open = false;
    }
  }
  ngOnDestroy() {
    this.clickListener();
    this._actionsSubject.unsubscribe();
  }
  static ɵfac = function ContextMenuComponent_Factory(t) {
    return new (t || ContextMenuComponent)(i0.ɵɵdirectiveInject(i1.TableServiceV2), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ElementRef));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: ContextMenuComponent,
    selectors: [["geaui-context-menu"]],
    decls: 3,
    vars: 5,
    consts: [[1, "context-menu-wrapper", 3, "click", "ngClass"], ["file", "16px_menu-dots", "color", "black", "colorProp", "both", 1, "menu-dots", 3, "clickable"], ["class", "menu-container", 4, "ngIf"], [1, "menu-container"], ["class", "menu-item", "tooltipPosition", "bottom", 3, "pTooltip", "tooltipDisabled", "ngClass", "dblclick", "click", 4, "ngFor", "ngForOf"], ["tooltipPosition", "bottom", 1, "menu-item", 3, "dblclick", "click", "pTooltip", "tooltipDisabled", "ngClass"], [3, "fileSize", "file", "color"]],
    template: function ContextMenuComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function ContextMenuComponent_Template_div_click_0_listener($event) {
          return ctx.toggleContextMenu($event);
        });
        i0.ɵɵelement(1, "geaui-icon-v2", 1);
        i0.ɵɵtemplate(2, ContextMenuComponent_div_2_Template, 2, 1, "div", 2);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c0, ctx.open));
        i0.ɵɵadvance();
        i0.ɵɵproperty("clickable", true);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.open);
      }
    },
    dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i3.IconComponent, i4.Tooltip, i5.TranslatePipe],
    styles: ["[_nghost-%COMP%]{position:relative}[_nghost-%COMP%]   .menu-dots[_ngcontent-%COMP%]{cursor:pointer}[_nghost-%COMP%]   .context-menu-wrapper[_ngcontent-%COMP%]{position:absolute;top:-26px;left:-18px;height:50px;width:50px;display:flex;justify-content:center;align-items:center}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]{position:absolute;top:35px;right:0;border:2px solid var(--geaui-grey-03);background-color:var(--geaui-pure-white);z-index:3}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]   .menu-item[_ngcontent-%COMP%]{display:flex;align-items:center;padding:12px 20px 12px 16px;cursor:pointer}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]   .menu-item[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-left:8px;font-size:16px;font-weight:400;color:var(--geaui-primary-black)}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]   .menu-item[_ngcontent-%COMP%]:hover{background-color:var(--geaui-secondary-hover)}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]   .disabledMenuItem[_ngcontent-%COMP%]{cursor:default}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]   .disabledMenuItem[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:var(--geaui-grey-01)}[_nghost-%COMP%]   .menu-container[_ngcontent-%COMP%]   .disabledMenuItem[_ngcontent-%COMP%]:hover{background-color:#fff}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ContextMenuComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-context-menu',
      template: "<div class=\"context-menu-wrapper\" [ngClass]=\"{ 'index-up': open }\" (click)=\"toggleContextMenu($event)\">\n  <geaui-icon-v2 class=\"menu-dots\" [clickable]=\"true\" file=\"16px_menu-dots\" color=\"black\" colorProp=\"both\"></geaui-icon-v2>\n  <div class=\"menu-container\" *ngIf=\"open\">\n    <div\n      class=\"menu-item\"\n      *ngFor=\"let item of config?.items\"\n      [pTooltip]=\"item?.disabledTranslationKey ?? 'X.INFO.NO_ACCESS.ACTION_UNAVAILABLE' | translate\"\n      [tooltipDisabled]=\"!isItemDisabled(item.action)\"\n      [ngClass]=\"{ disabledMenuItem: isItemDisabled(item.action) }\"\n      (dblclick)=\"$event.stopPropagation()\"\n      (click)=\"isItemDisabled(item.action) ? $event.stopPropagation() : menuItemClicked(item.action, $event)\"\n      tooltipPosition=\"bottom\">\n      <geaui-icon-v2 [fileSize]=\"16\" [file]=\"item.icon\" [color]=\"isItemDisabled(item.action) ? 'grey' : 'black'\"></geaui-icon-v2>\n      <span>{{ item.text | translate }}</span>\n    </div>\n  </div>\n</div>\n",
      styles: [":host{position:relative}:host .menu-dots{cursor:pointer}:host .context-menu-wrapper{position:absolute;top:-26px;left:-18px;height:50px;width:50px;display:flex;justify-content:center;align-items:center}:host .menu-container{position:absolute;top:35px;right:0;border:2px solid var(--geaui-grey-03);background-color:var(--geaui-pure-white);z-index:3}:host .menu-container .menu-item{display:flex;align-items:center;padding:12px 20px 12px 16px;cursor:pointer}:host .menu-container .menu-item span{margin-left:8px;font-size:16px;font-weight:400;color:var(--geaui-primary-black)}:host .menu-container .menu-item:hover{background-color:var(--geaui-secondary-hover)}:host .menu-container .disabledMenuItem{cursor:default}:host .menu-container .disabledMenuItem span{color:var(--geaui-grey-01)}:host .menu-container .disabledMenuItem:hover{background-color:#fff}\n"]
    }]
  }], () => [{
    type: i1.TableServiceV2
  }, {
    type: i0.Renderer2
  }, {
    type: i0.ElementRef
  }], null);
})();
